import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-call-history',
  templateUrl: './call-history.component.html',
  styleUrls: ['./call-history.component.scss']
})
export class CallHistoryComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
